import HallCreateModal from "./hall-create-modal";

export default HallCreateModal;
